import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/manualExchangeRatesHistory', request)
}

export {get}
